var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteEditorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 42"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 26",
    opacity: 0.05,
    cx: 28.7016,
    cy: 27.7445,
    r: 27.7445,
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Delete",
    d: "M37.7268 20.7501V37.8476C37.7268 39.5645 36.344 40.9562 34.6383 40.9562H22.2846C20.5788 40.9562 19.1961 39.5645 19.1961 37.8476V20.7501M37.7268 20.7501H39.271M37.7268 20.7501H34.6383M19.1961 20.7501H17.6519M19.1961 20.7501H22.2846M34.6383 20.7501V17.6415C34.6383 15.9246 33.2556 14.5328 31.5499 14.5328H25.373C23.6672 14.5328 22.2846 15.9246 22.2846 17.6415V20.7501M34.6383 20.7501H22.2846M31.5499 26.9674V34.7389M25.373 26.9674V34.7389",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteEditorIcon);
export default __webpack_public_path__ + "static/media/deleteEditorIcon.a9f6d029c63a82453a0f2f7a4df7cd76.svg";
export { ForwardRef as ReactComponent };